import { Tooltip } from "antd";
import React from "react";
import { useNavigate } from "react-router";
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { lockAudio } from "../../../redux/Transcribe/TranscribeAction";
import { FontIcon } from "@fluentui/react";
interface PlayButtonProps {
  disabled?: boolean;
  record: any;
}

function PlayButtton({ disabled, record }: PlayButtonProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  return (
    <Tooltip
      placement="bottom"
      title="">
      <button
        disabled={disabled}
        onClick={() => {
          dispatch(lockAudio(record.packId));
          navigate(`/auth/pack/${record.packId}`);
        }}
        className="button action">
        <FontIcon iconName="Play"/>
      </button>
    </Tooltip>
  );
}

export default PlayButtton;
